import { Avatar } from "@mantine/core";

const SaveIcon = ({ size }: any) => {
  return (
    <Avatar
      style={{
        cursor: "pointer",
      }}
      size={size}
      src={"/assets/saveIcon.png"}
    />
  );
};

export default SaveIcon;
